import {useState} from "react";
import {useSelector} from "react-redux";
import {selectUserId} from "../../store/features/Auth/authSlice.ts";
import {buildQueryParams} from "../../utilis/buildQueryParams.ts";
import {
    GroupListItem,
    useFetchGroupsAdminQuery,
    useFetchGroupsQuery,
    FetchGroupsResponse
} from "../../store/features/groups/groupsService.ts";
import {PhoneHQIconAvatar} from 'ch3-ui-lib';

interface UseGroupFiltersProps {
    selectedGroups: GroupListItem[];
    setSelectedGroups: (groups: GroupListItem[]) => void;
    admin?: boolean;
}

interface UseGroupFiltersReturn {
    groupPhrase: string;
    setGroupPhrase: (phrase: string) => void;
    groups: any[];
    handleGroupSelect: (value: GroupListItem) => void;
    isLoading?: boolean;
    error?: any;
    onScrollEnd: () => void;
}

export const useGroupFilters = ({
                                    selectedGroups,
                                    setSelectedGroups,
                                    admin = false
                                }: UseGroupFiltersProps): UseGroupFiltersReturn => {
    const [groupPhrase, setGroupPhrase] = useState<string>('');
    const [groupsQuery, setGroupsQuery] = useState<any>({});
    const userId = useSelector(selectUserId);

    const groupQueryParams = buildQueryParams({
        phrase: groupPhrase,
        userId,
        ...groupsQuery
    });

    const {data: groupsData, isLoading, error} = admin
        ? useFetchGroupsAdminQuery(groupQueryParams, { skip: false })
        : useFetchGroupsQuery(groupQueryParams, { skip: admin });

    const {data: adminGroupsData} = admin
        ? useFetchGroupsAdminQuery(groupQueryParams, { skip: !admin })
        : { data: null };

    const currentData = admin ? adminGroupsData : groupsData;

    const onScrollEnd = () => {
        const lastGroup = currentData?.groups?.at(-1);

        if (lastGroup) {
            setGroupsQuery((prevQuery: any) => ({
                ...prevQuery,
                lastName: lastGroup?.group.name,
                lastGroupId: lastGroup?.group.groupId
            }));
        }
    };

    const groups = currentData?.groups ? currentData?.groups?.map((el: FetchGroupsResponse) => ({
        key: `group${el.group.groupId}`,
        label: el.group.name,
        value: el.group,
        prefixElement: (
            <div className='ml-2'>
                <PhoneHQIconAvatar icon={el.group.icon ?? 'default'} color={el.group.iconColor ?? 'auto'} size="24px"/>
            </div>
        ),
        type: 'checkbox'
    })) : [];

    const handleGroupSelect = (value: GroupListItem) => {
        const exists = selectedGroups.some(item => item.groupId === value.groupId);

        const newSelectedGroups = exists
            ? selectedGroups.filter(item => item.groupId !== value.groupId)
            : [...selectedGroups, value];

        setSelectedGroups(newSelectedGroups);
    };

    return {
        groupPhrase,
        setGroupPhrase,
        groups,
        handleGroupSelect,
        isLoading,
        error,
        onScrollEnd
    };
};